import { useColorMode } from '@chakra-ui/react'
import { useEffect } from 'react'
import { Auth0Provider } from '@auth0/auth0-react'
import './app.css'
import { UserProvider } from '@ocean/shared/contexts/UserContext'
import { Router } from '@ocean/shared/router/Router'
import { useBulkJobAutoResume } from '@ocean/shared/hooks/useBulkJobAutoResume'
import { HotkeyBlockProvider } from '@ocean/shared/hooks/useHotkeyBlock'
import { Helmet } from 'react-helmet'
import { HashRouter } from 'react-router-dom'

const AppShell = () => {
  const { colorMode, toggleColorMode } = useColorMode()
  useEffect(() => {
    if (colorMode === 'dark') toggleColorMode()
  }, [colorMode, toggleColorMode])

  // Auto-resume interrupted bulk jobs globally
  useBulkJobAutoResume()

  return (
    <>
      <Helmet>
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="manifest" href="/site.webmanifest" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#090369" />
        <meta name="msapplication-TileColor" content="#090369" />
        <meta name="theme-color" content="#090369" />
        <meta name="apple-mobile-web-app-status-bar-style" content="#090369" />
        <script src="/newrelic.js" type="text/javascript" />
      </Helmet>
      <HotkeyBlockProvider>
        <UserProvider>
          <HashRouter>
            <Router />
          </HashRouter>
        </UserProvider>
      </HotkeyBlockProvider>
    </>
  )
}

const App = () => {
  const onRedirectCallback = (appState?: { returnTo?: string }) => {
    sessionStorage.removeItem('logging_out')
    const returnTo = appState?.returnTo ?? '/react/dashboard'
    const normalizedReturnTo = returnTo.startsWith('/') ? returnTo : `/${returnTo}`
    window.history.replaceState({}, '', globalThis.location.origin + globalThis.location.hash)
    globalThis.location.hash = normalizedReturnTo
  }

  return (
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      cacheLocation="localstorage"
      useRefreshTokens
      authorizationParams={{
        redirect_uri: globalThis.location.origin,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
        scope: 'openid profile email offline_access',
      }}
      onRedirectCallback={onRedirectCallback}
    >
      <AppShell />
    </Auth0Provider>
  )
}

export default App
